export const YANDEX_MAP_TYPE = 'yandex#map'
export const TWO_GIS_MAP_TYPE = '2gis#map'
